export default __webpack_public_path__ + "static/media/postfeet.642884ca.mp4";